import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectFormListAvailable = createSelector(
  [
    (store: RootState) => store.profileFormAssigned.formList,
    (store: RootState) => store.profileFormAssigned.searchText,
    (store: RootState) => store.profileFormAssigned.preselectedForms,
  ],
  (forms, searchText, preselectedForms) => forms?.filter((
    { id, name }) => {
      // Filtro de plantillas por nombre
    if (
      searchText
      && !name?.toLowerCase().includes(searchText?.toLowerCase().trim())
    ) {
      return false;
    }
     // Descarta las plantillas que ya están seleccionadas o asignadas
     if (preselectedForms.find(( { id: formId }) => formId === id)) {
      return false;
    }
    return true
  })
);
